import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import DocsPage from "./pages/DocsPage";
import WhitepaperPage from "./pages/WhitepaperPage";
import MigratePage from "./pages/MigratePage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import NotFoundPage from "./pages/NotFoundPage";
import Layout from "./components/Shared/Layout/Layout";

function AppContent() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Layout>
            <HomePage />
          </Layout>
        }
      />
      <Route
        path="/docs"
        element={
          <Layout>
            <DocsPage />
          </Layout>
        }
      />
      <Route
        path="/docs/whitepaper"
        element={
          <Layout>
            <WhitepaperPage />
          </Layout>
        }
      />
      <Route
        path="/migrate"
        element={
          <Layout>
            <MigratePage />
          </Layout>
        }
      />
      <Route
        path="/terms"
        element={
          <Layout>
            <TermsPage />
          </Layout>
        }
      />
      <Route
        path="/privacy"
        element={
          <Layout>
            <PrivacyPage />
          </Layout>
        }
      />
      <Route
        path="*"
        element={
          <Layout>
            <NotFoundPage />
          </Layout>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
